import React from 'react';
import { ChevronRight } from 'lucide-react';
import CTAButton from '../components/CTAButton';
import SectionHeading from '../components/SectionHeading';
import TestimonialCard from '../components/TestimonialCard';
const HomePage = () => {
  return <div className="w-full" data-id="element-1323">
      {/* Statement Section */}
      <section className="bg-white py-10 border-b border-gray-200" data-id="element-1324">
        <div className="container-custom" data-id="element-1325">
          <h2 className="text-2xl md:text-3xl font-bold text-navy text-center font-montserrat leading-tight" data-id="element-1326">
            Empowering Aspiring Entrepreneurs to Build Thriving Businesses that{' '}
            <span className="text-gold" data-id="element-1327">Generates Profits</span>, Creates Jobs,
            Makes an <span className="text-gold" data-id="element-1328">Impact</span>, and Leaves a{' '}
            <span className="text-gold" data-id="element-1329">Legacy</span>.
          </h2>
        </div>
      </section>
      {/* Mission Overview Section */}
      <section className="section-padding bg-lightGray" data-id="element-1330">
        <div className="container-custom" data-id="element-1331">
          <SectionHeading title="Our Mission" subtitle="We believe that with the right support, aspiring entrepreneurs can transform their passion and vision into business success." data-id="element-1332" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1333">
            <MissionCard icon="🎯" title="Purpose-Driven" description="We help entrepreneurs connect their personal purpose to business success, creating ventures with meaning and impact." data-id="element-1334" />
            <MissionCard icon="🛠️" title="Hard Work Pays Off" description="We provide the tools, but success comes from your commitment to putting in the effort required to build a thriving business." data-id="element-1335" />
            <MissionCard icon="🤝" title="Community Support" description="Join a network of like-minded entrepreneurs who understand your journey and support your growth every step of the way." data-id="element-1336" />
          </div>
          <div className="mt-12 text-center" data-id="element-1337">
            <CTAButton text="Discover Our Programs" to="/programs" data-id="element-1338" />
          </div>
        </div>
      </section>
      {/* Veterans Program Section */}
      <section className="section-padding bg-white" data-id="element-1339">
        <div className="container-custom" data-id="element-1340">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1341">
            <div data-id="element-1342">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jJStBdptK8ddFxenDwjw5Q/military-to-entrepreneur.png" alt="Military veteran transitioning to business" className="rounded-lg shadow-md w-full h-auto" data-id="element-1343" />
            </div>
            <div data-id="element-1344">
              <h2 className="text-3xl font-bold text-navy mb-6 font-montserrat" data-id="element-1345">
                Veterans Business Launchpad
              </h2>
              <p className="mb-4 text-lg" data-id="element-1346">
                From serving your country to building your legacy. Operation
                Launchpad is proud to offer specialized support for military
                veterans and active service members preparing for discharge.
              </p>
              <p className="mb-6" data-id="element-1347">
                Our Veterans Business Launchpad program translates your military
                discipline, leadership, and problem-solving skills into
                entrepreneurial success. We provide the training, mentorship,
                and resources you need to build a thriving business.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-1348">
                <CTAButton text="Learn More" to="/programs" data-id="element-1349" />
                <a href="/apply" className="inline-flex items-center text-navy font-bold hover:text-orange transition duration-300" data-id="element-1350">
                  Apply to Veterans Program
                  <ChevronRight size={20} className="ml-2" data-id="element-1351" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Success Stories Section */}
      <section className="section-padding bg-lightGray" data-id="element-1352">
        <div className="container-custom" data-id="element-1353">
          <SectionHeading title="Success Stories" subtitle="Meet the entrepreneurs who transformed their vision into thriving businesses." data-id="element-1354" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1355">
            <TestimonialCard quote="Operation Launchpad gave me the blueprint and support I needed to scale my tech startup from $200K to over $1.2M in just 18 months." name="Michael Rodriguez" title="CEO of Rodriguez Technologies" image="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80" data-id="element-1356" />
            <TestimonialCard quote="The mentorship and business systems provided by Operation Launchpad helped me avoid years of trial and error. My e-commerce company hit $1M in our second year." name="Sarah Johnson" title="Founder of Johnson Retail" image="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80" data-id="element-1357" />
            <TestimonialCard quote="I knew how to lead a team, but Operation Launchpad taught me how to build a business. Now my consulting firm employs 15 people and serves major clients." name="David Thompson" title="Owner of Thompson Consulting" image="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80" data-id="element-1358" />
          </div>
          <div className="mt-12 text-center" data-id="element-1359">
            <a href="/impact" className="inline-flex items-center text-navy font-bold hover:text-orange transition duration-300" data-id="element-1360">
              View More Success Stories
              <ChevronRight size={20} className="ml-2" data-id="element-1361" />
            </a>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-navy text-white py-16" data-id="element-1362">
        <div className="container-custom text-center" data-id="element-1363">
          <h2 className="text-3xl md:text-4xl font-bold font-montserrat mb-6" data-id="element-1364">
            Ready to Build Your Business Legacy?
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto" data-id="element-1365">
            Hard work pays off when purpose meets opportunity. Apply today to
            join our community of dedicated entrepreneurs.
          </p>
          <CTAButton text="Apply Now" to="/apply" className="text-lg" data-id="element-1366" />
        </div>
      </section>
    </div>;
};
const MissionCard = ({
  icon,
  title,
  description
}) => {
  return <div className="bg-white rounded-lg shadow-md p-6 transition duration-300 hover:shadow-lg" data-id="element-1367">
      <div className="text-4xl mb-4" data-id="element-1368">{icon}</div>
      <h3 className="text-xl font-bold text-navy mb-3 font-montserrat" data-id="element-1369">
        {title}
      </h3>
      <p className="text-darkGray" data-id="element-1370">{description}</p>
    </div>;
};
export default HomePage;